export default __webpack_public_path__ + "static/media/word.8cc3ddd8.svg";